import React from "react";
import { Dialog, DialogContent, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

type AgentConnectionStatus = {
  isAgentConnected: boolean;
  message?: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  agentConnectionStatus?: AgentConnectionStatus | null;
};

const NoTasksModal: React.FC<Props> = ({ open, onClose, agentConnectionStatus }) => {
  const { t } = useTranslation();

  const isJessOffline = !agentConnectionStatus?.isAgentConnected;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus={true} // Allows interaction with elements outside the dialog
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: "1em",
          boxShadow: "0 0.5em 1.5em rgba(0,0,0,0.3)",
        },
      }}
    >
      <DialogContent
        sx={{
          px: "2em",
          py: "2em",
          textAlign: "center",
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={600} color="text.primary">
            {isJessOffline ? t("noTasksModal.titleOffline") : t("noTasksModal.title")}
          </Typography>
          <Typography variant="h6" fontWeight={400} color="text.secondary">
            {isJessOffline ? t("noTasksModal.subtitleOffline") : t("noTasksModal.subtitle")}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NoTasksModal;
